export type ToolTipType = 'top' | 'topLeft' | 'topRight' | 'bottom' | 'bottomRight';

export const TOOLTIP_POSITIONS = {
  TOP: 'top',
  TOP_RIGHT: 'topRight',
  TOP_LEFT: 'topLeft',
  BOTTOM: 'bottom',
  BOTTOM_RIGHT: 'bottomRight',
} as const;
